export default theme => ({
  radio: {
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row!important',
    },
    margin: '0.5rem 0',
  },
});
